import { render, staticRenderFns } from "./ProjektStartenProcess.vue?vue&type=template&id=5c6c5cb0&scoped=true&"
import script from "./ProjektStartenProcess.vue?vue&type=script&lang=js&"
export * from "./ProjektStartenProcess.vue?vue&type=script&lang=js&"
import style0 from "./ProjektStartenProcess.vue?vue&type=style&index=0&id=5c6c5cb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c5cb0",
  null
  
)

export default component.exports